export default __webpack_public_path__ + "static/media/RENDER - apple.3adc69d9.png";